import axios from 'axios'
import moment from 'moment'
import AxiosInstance from 'utils/AxiosInstance'
import * as types from './types'

import {
  BASE_URL_API as baseURLNode,
  ACCESS_TOKEN as accessToken,
  randomString,
} from 'utils/helpers'
import { clientBaseUrl } from 'utils/AxiosInstance'
import { SET_AREAS } from 'store/ManagerReport/constants'

/*eslint-disable */
export const resetGroup = () => ({ type: types.RESET_GROUP })
export const resetGroupDetails = () => ({
  type: types.RESET_GROUP_DETAILS_DATA,
})
export const resetSelectedItems = () => ({ type: types.RESET_SELECTED_ITEMS })
export const onNameChange = (value) => ({
  type: types.PROPERTY_GROUP_NAME_CHANGE,
  value,
})
export const selectRole = (roles) => ({ type: types.SELECT_ROLE, roles })
export const undo = () => ({ type: types.UNDO })
export const present = () => ({ type: types.PRESENT })
export const setGroupClone = () => ({ type: types.GROUP_CLONED, data: null })
export const setCourseIndex = (index) => ({
  type: types.SET_COURSE_INDEX,
  index,
})
export const toggleLearningPlan = (show) => ({
  type: types.TOGGLE_LEARNING_PLAN,
  show,
})
export const filterGroupCourses = (value) => ({
  type: types.FILTER_GROUP_COURSES,
  value,
})
export const filterGroupLocations = (value) => ({
  type: types.FILTER_GROUP_LOCATIONS,
  value,
})
export const filterGroupUsers = (value) => ({
  type: types.FILTER_GROUP_USERS,
  value,
})
export const filterGroupRoles = (value) => ({
  type: types.FILTER_GROUP_ROLES,
  value,
})
export const filterRoleGroups = (value) => ({
  type: types.FILTER_ROLE_GROUPS,
  value,
})
export const filterGroupAssociates = (value) => ({
  type: types.FILTER_GROUP_ASSOCIATES,
  value,
})
export const setGroupSearchValue = (value) => ({
  type: types.SET_GROUP_SEARCH_VALUE,
  value,
})
export const setShowSelectedItems = () => ({
  type: types.SET_SHOW_SELECTED_ITEMS,
  showSelectedItems: true,
})
export const setHideSelectedItems = () => ({
  type: types.SET_SHOW_SELECTED_ITEMS,
  showSelectedItems: false,
})
export const setShowSelectedLocationItems = () => ({
  type: types.SET_SHOW_SELECTED_LOCATION_ITEMS,
  showSelectedLocationItems: true,
})
export const setHideSelectedLocationItems = () => ({
  type: types.SET_SHOW_SELECTED_LOCATION_ITEMS,
  showSelectedLocationItems: false,
})
export const setShowSelectedLocations = () => ({
  type: types.SET_SHOW_SELECTED_LOCATION,
  showSelectedLocations: true,
})
export const setHideSelectedLocations = () => ({
  type: types.SET_SHOW_SELECTED_LOCATION,
  showSelectedLocations: false,
})
export const setShowSelectedStores = () => ({
  type: types.SET_SHOW_SELECTED_STORES,
  showSelectedStores: true,
})
export const setHideSelectedStores = () => ({
  type: types.SET_SHOW_SELECTED_STORES,
  showSelectedStores: false,
})
export const setShowSelectedRoles = () => ({
  type: types.SET_SHOW_SELECTED_ROLES,
  showSelectedRoles: true,
})
export const setHideSelectedRoles = () => ({
  type: types.SET_SHOW_SELECTED_ROLES,
  showSelectedRoles: false,
})

export const setShowSelectedRoleGroups = () => ({
  type: types.SET_SHOW_SELECTED_ROLE_GROUPS,
  showSelectedRoleGroups: true,
})
export const setHideSelectedRoleGroups = () => ({
  type: types.SET_SHOW_SELECTED_ROLE_GROUPS,
  showSelectedRoleGroups: false,
})
export const setHideAssignExpanded = () => ({
  type: types.SET_ASSIGN_EXPANDED,
  assignExpanded: false,
})
export const setShowAssignExpanded = () => ({
  type: types.SET_ASSIGN_EXPANDED,
  assignExpanded: true,
})
export const setHideManageExpanded = () => ({
  type: types.SET_MANAGE_EXPANDED,
  manageExpanded: false,
})
export const setShowManageExpanded = () => ({
  type: types.SET_MANAGE_EXPANDED,
  manageExpanded: true,
})
export const setSwitchToDate = () => ({ type: types.SET_EXPIRATION_TO_DATE })
export const setSwitchToDuration = () => ({
  type: types.SET_EXPIRATION_TO_DURATION,
})
export const setSwitchToDisabledDates = () => {
  return (dispatch) => {
    dispatch({ type: types.SET_EXPIRATION_TO_DISABLED })
  }
}
export const toggleDoNotAssign = () => ({ type: types.TOGGLE_DO_NOT_ASSIGN })
export const toggleAutomaticEnrollment = () => ({
  type: types.TOGGLE_AUTOMATIC_ENROLLMENT,
})

export const togglePinToNavbar = (show) => ({
  type: types.TOGGLE_PIN_TO_NAVBAR,
  show,
})

export const togglePinToNavbarDevelopment = (show) => {
  console.log('leart147', show) // Log the value of 'show'
  return {
    type: types.TOGGLE_PIN_TO_NAVBAR_DEVELOPMENT,
    show,
  }
}

export const toggleEnableReorder = () => ({
  type: types.TOGGLE_ENABLE_REORDER,
})
//recently addedx
export const toggleEnableGroupReorder = () => ({
  type: types.TOGGLE_ENABLE_GROUP_REORDER,
})

export const toggleInactive = () => ({ type: types.SET_GROUP_INACTIVE })

export const toggleExpireDate = () => {
  return (dispatch, getState) => {
    const { hasExpireDate } = getState().groups

    if (!hasExpireDate) {
      dispatch({ type: types.SET_EXPIRE_PERIOD, value: 'm' })
      dispatch({ type: types.SET_EXPIRE_PRIOR, value: 'd' })
      dispatch({ type: types.SET_EXPIRE_DATE, value: null })
      dispatch({ type: types.SET_REASSIGN_DATE, value: null })
    }
    dispatch({ type: types.TOGGLE_EXPIRE_DATE })
  }
}

export const setUserRoles = (roles) => {
  console.log('leart179', roles)
  return (dispatch, getState) => {
    const conditions = [`role=${roles}`]

    AxiosInstance.get(`/users/details/extended?${conditions.join('&')}`).then(
      (data) => {
        dispatch({ type: types.SET_SELECTED_ROLES, payload: roles })
        dispatch({ type: types.SET_USER_ROLES, payload: data })
      }
    )
  }
}

export const hideUserRoles = () => {
  return (dispatch) => {
    dispatch({ type: types.SET_SELECTED_ROLES, payload: null })
  }
}

export const toggleCourse = (id) => {
  return (dispatch, getState) => {
    const { selectedCourses } = getState().groups
    const index = selectedCourses.findIndex((item) => item === id)

    if (index === -1) {
      dispatch({
        type: types.PROPERTY_GROUP_COURSES_CHANGE,
        courses: [...selectedCourses, id],
      })

      return
    }

    const newCourses = [
      ...selectedCourses.slice(0, index),
      ...selectedCourses.slice(index + 1),
    ]

    dispatch({ type: types.PROPERTY_GROUP_COURSES_CHANGE, courses: newCourses })
  }
}

export const groupCoursePositionChange = (id, position) => {
  return (dispatch, getState) => {
    const { selectedCoursesWithPosition } = getState().groups
    let newCourses = selectedCoursesWithPosition.filter(
      (item) => item.course_id !== id
    )
    newCourses = [
      ...newCourses,
      {
        course_id: id,
        position: parseInt(position) > 0 ? parseInt(position) : null,
      },
    ]
    dispatch({ type: types.GROUP_COURSE_POSITION_CHANGE, courses: newCourses })
  }
}

export const toggleModule = (id) => {
  return (dispatch, getState) => {
    const { modules } = getState().groups.group.permissions
    const index = modules.findIndex((item) => item === id)

    if (index === -1) {
      dispatch({
        type: types.PROPERTY_GROUP_MODULES_CHANGE,
        modules: [...modules, id],
      })

      return
    }

    const newModules = [...modules.slice(0, index), ...modules.slice(index + 1)]

    dispatch({ type: types.PROPERTY_GROUP_MODULES_CHANGE, modules: newModules })
  }
}

export const createGroup = () => {
  return (dispatch, getState) => {
    const { name, show_in_learning_plan } = getState().groups.group

    const tags = getState().groups.tags

    const {
      groups,
      selectedCourses,
      assignableTrainingUsers,
      manageableTrainingUsers,
      assignableTrainingLocations,
      manageableTrainingLocations,
      assignableTrainingStores,
      manageableTrainingStores,
      assignableTrainingRoles,
      assignableTrainingRoleGroups,
      manageableTrainingRoles,
      assignableTrainingLocationGroups,
      manageableTrainingLocationGroups,
      startDate,
      endDate,
      duration,
      datesDisabled,
      hasDate,
      hasDuration,
      doNotAssign,
      automaticEnrollment,
      pinToNavbar,
      pinToNavbarDevelopment,
      enableReorder,
      trainingWithCourses,
      hasExpireDate,
      expireDate,
      reassignDate,
      expirePeriod,
      expirePrior,
      groupsCourses,
      learningPlanGroups,
      inactive,
      equivalentGroup,
      setUserNotAssignedFromRole,
    } = getState().groups

    let selectedUsers = []
    let selectedLocations = []
    let selectedStores = []
    let selectedRoles = []
    let selectedAssociates = []
    let selectedRoleGroups = []
    let selectUsersNotAssignedFromRole = []

    if (assignableTrainingUsers.length) {
      assignableTrainingUsers.map((item) => {
        const assignableItem = {
          user_id: item,
          assigned: true,
          manageable: false,
        }
        selectedUsers.push(assignableItem)
      })
    }

    if (manageableTrainingUsers.length) {
      manageableTrainingUsers.map((item) => {
        const currentUser = selectedUsers.find(
          (selectedItem) => selectedItem.user_id === item
        )
        if (currentUser) {
          currentUser.manageable = true
        } else {
          const manageableItem = {
            user_id: item,
            assigned: false,
            manageable: true,
          }
          selectedUsers.push(manageableItem)
        }
      })
    }

    if (assignableTrainingLocations.length) {
      assignableTrainingLocations.map((item) => {
        const assignableItem = {
          location_id: item,
          assigned: true,
          manageable: false,
        }
        selectedLocations.push(assignableItem)
      })
    }

    if (setUserNotAssignedFromRole.length) {
      setUserNotAssignedFromRole.map((item) => {
        const assignableItem = {
          user_id: item,
          assigned: true,
          manageable: false,
        }
        selectUsersNotAssignedFromRole.push(assignableItem)
      })
    }

    if (assignableTrainingRoleGroups.length) {
      assignableTrainingRoleGroups.map((item) => {
        const assignableItem = {
          associate_id: item,
          assigned: true,
          manageable: false,
        }
        selectedRoleGroups.push(assignableItem)
      })
    }

    if (manageableTrainingLocations.length) {
      manageableTrainingLocations.map((item) => {
        const currentLocation = selectedLocations.find(
          (selectedItem) => selectedItem.location_id === item
        )
        if (currentLocation) {
          currentLocation.manageable = true
        } else {
          const manageableItem = {
            location_id: item,
            assigned: false,
            manageable: true,
          }
          selectedLocations.push(manageableItem)
        }
      })
    }

    if (assignableTrainingStores.length) {
      assignableTrainingStores.map((item) => {
        const assignableItem = {
          location_id: item,
          assigned: true,
          manageable: false,
        }
        selectedStores.push(assignableItem)
      })
    }

    if (manageableTrainingStores.length) {
      manageableTrainingStores.map((item) => {
        const currentStore = selectedStores.find(
          (selectedItem) => selectedItem.location_id === item
        )
        if (currentStore) {
          currentStore.manageable = true
        } else {
          const manageableItem = {
            location_id: item,
            assigned: false,
            manageable: true,
          }
          selectedStores.push(manageableItem)
        }
      })
    }

    if (assignableTrainingRoles.length) {
      assignableTrainingRoles.map((item) => {
        const assignableItem = {
          role_id: item,
          assigned: true,
          manageable: false,
        }
        selectedRoles.push(assignableItem)
      })
    }

    if (manageableTrainingRoles.length) {
      manageableTrainingRoles.map((item) => {
        const currentRole = selectedRoles.find(
          (selectedItem) => selectedItem.role_id === item
        )
        if (currentRole) {
          currentRole.manageable = true
        } else {
          const manageableItem = {
            role_id: item,
            assigned: false,
            manageable: true,
          }
          selectedRoles.push(manageableItem)
        }
      })
    }

    if (assignableTrainingLocationGroups.length) {
      assignableTrainingLocationGroups.map((item) => {
        const assignableItem = {
          associate_id: item,
          assigned: true,
          manageable: false,
        }
        selectedAssociates.push(assignableItem)
      })
    }

    if (manageableTrainingLocationGroups.length) {
      manageableTrainingLocationGroups.map((item) => {
        const currentAssociate = selectedAssociates.find(
          (selectedItem) => selectedItem.associate_id === item
        )
        if (currentAssociate) {
          currentAssociate.manageable = true
        } else {
          const manageableItem = {
            associate_id: item,
            assigned: false,
            manageable: true,
          }
          selectedAssociates.push(manageableItem)
        }
      })
    }

    AxiosInstance.post('/groups', {
      name,
      type: 'course',
      users: JSON.stringify(selectedUsers),
      courses: JSON.stringify(selectedCourses),
      roles: JSON.stringify(selectedRoles),
      roleGroups: JSON.stringify(selectedRoleGroups),
      groups: JSON.stringify(selectedAssociates),
      locations: JSON.stringify(selectedStores),
      usersNotAssigned: JSON.stringify(selectUsersNotAssignedFromRole),
      show_in_learning_plan,
      start_date:
        hasDate && startDate
          ? moment(startDate).format('YYYY-MM-DD HH:MM:SS')
          : null,
      end_date:
        hasDate && endDate
          ? moment(startDate).format('YYYY-MM-DD HH:MM:SS')
          : null,
      duration:
        !hasDuration || parseInt(duration) !== 0 ? parseInt(duration) : null,
      expire_time: hasExpireDate
        ? expireDate
          ? expireDate + expirePeriod
          : null
        : null,
      expire_reassign_time: hasExpireDate
        ? reassignDate
          ? reassignDate + expirePrior
          : null
        : null,
      tags: JSON.stringify(tags),
      dates_disabled: datesDisabled ? 1 : 0,
      assignable: doNotAssign ? -1 : 1,
      automatic_enrollment: automaticEnrollment ? 1 : 0,
      pin_to_navbar: pinToNavbar ? 1 : 0,
      pin_to_navbar_development: pinToNavbarDevelopment ? 1 : 0,
      enable_reorder: enableReorder ? 1 : 0,
      is_active: inactive === true ? -1 : 1,
      equivalent_id: equivalentGroup ? equivalentGroup : null,
    }).then((group) => {
      if (group.id) {
        group.id = parseInt(group.id)
        group.assignable = parseInt(group.assignable)
        group.automatic_enrollment = parseInt(group.automatic_enrollment)
        group.show_in_learning_plan = parseInt(group.show_in_learning_plan)
        group.duration = parseInt(group.duration)
        group.dates_disabled = parseInt(group.dates_disabled)
        group.expire_time = parseInt(group.expireDate)
        group.expire_reassign_time = parseInt(group.reassignDate)
        group.tags ? (group.tags = JSON.parse(group.tags)) : null
        group.inactive = parseInt(group.is_active) === 1 ? false : true
        group.equivalentGroup = parseInt(group.equivalent_id)
        group.expireDate = parseInt(group.expireDate)
        group.reassignDate = parseInt(group.reassignDate)

        const newGroups = [...groups, group]
        const newTrainingWithCourses = [...trainingWithCourses, group]

        let newGroupsCourses = groupsCourses
        let groupCourse = []
        let newLearningPlanGroups = learningPlanGroups

        if (selectedCourses.length) {
          selectedCourses.map((item) => {
            groupCourse.push({ course_id: item, group_id: group.id })
          })
        }

        newGroupsCourses[group.id] = groupCourse

        newLearningPlanGroups.push(group)

        dispatch({
          type: types.SET_GROUPS_LEARNING_PLAN,
          groups: newLearningPlanGroups,
        })
        dispatch({
          type: types.SET_GROUPS_COURSES,
          courses: newGroupsCourses,
        })
        dispatch({ type: types.SET_GROUPS, groups: newGroups })
        dispatch({
          type: types.SET_TRAININGS_WITH_COURSES,
          trainings: newTrainingWithCourses.sort((a, b) =>
            a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
          ),
        })
        dispatch({ type: types.SET_TAGS, tags: null })
      }
    })
  }
}

export const fetchGroup = (id) => {
  return (dispatch) => {
    AxiosInstance.get(`/groups/${id}/details`).then((group) => {
      if (group) {
        dispatch({
          type: types.SET_GROUP,
          group: group,
          startDate: group.start_date,
          endDate: group.end_date,
          duration: group.duration,
          dates_disabled: group.dates_disabled ? true : false,
          datesDisabled: group.dates_disabled ? true : false,
          doNotAssign: group.assignable === 1 ? false : true,
          automaticEnrollment: group.automatic_enrollment === 1 ? true : false,
          pinToNavbar: group.pin_to_navbar === 1 ? true : false,
          enableReorder: group.enable_reorder === 1 ? true : false,
          inactive: group.is_active === 1 ? false : true,
          equivalentGroup: parseInt(group.equivalent_id),
          hasExpireDate: group.has_expire_date ? true : false,
          expireDate: group.expireDate,
          reassignDate: group.reassignDate,
          hasExpireDate: group.expire_time || group.expire_reassign_time,
          expireDate: group.expire_time
            ? group.expire_time.substring(0, group.expire_time.length - 1)
            : null,
          reassignDate: group.expire_reassign_time
            ? group.expire_reassign_time.substring(
                0,
                group.expire_reassign_time.length - 1
              )
            : null,
          hasDuration:
            group.duration &&
            (group.start_date === null || group.end_date === null) &&
            !group.dates_disabled
              ? true
              : false,
          hasDate:
            (group.start_date !== null || group.end_date !== null) &&
            !group.duration &&
            !group.dates_disabled
              ? true
              : false,
          checklist: {
            ...group.checklist,
            description:
              group.checklist && group.checklist.description
                ? group.checklist.description
                : {},
          },
        })

        group.expire_time
          ? dispatch({
              type: types.SET_EXPIRE_PERIOD,
              value: group.expire_time.substring(
                group.expire_time.length - 1,
                group.expire_time.length
              ),
            })
          : null
        group.expire_reassign_time
          ? dispatch({
              type: types.SET_EXPIRE_PRIOR,
              value: group.expire_reassign_time.substring(
                group.expire_reassign_time.length - 1,
                group.expire_reassign_time.length
              ),
            })
          : null

        dispatch({ type: types.SET_TAGS, tags: group.tags })
      }
    })
  }
}

export const fetchGroupCourses = (id) => {
  return (dispatch) => {
    AxiosInstance.get(`/groups/${id}/courses`).then((courses) => {
      if (Array.isArray(courses)) {
        dispatch({
          type: types.SET_GROUP_COURSES,
          courses: courses.map((item) => item.course_id),
        })
        dispatch({
          type: types.SET_GROUP_COURSES_WITH_POSITION,
          courses: courses,
        })
      }
    })
  }
}

export const setIndividualCourses = (id = null) => {
  return (dispatch, getState) => {
    const { progress } = getState().courses
    const { groupsCourses, groupsCoursesLoaded } = getState().groups

    // if (!groupsCoursesLoaded) {
    // 	return
    // }

    let groupsCoursesIds = []

    Object.keys(groupsCourses).map(
      (item) =>
        (groupsCoursesIds = [
          ...groupsCoursesIds,
          ...groupsCourses[item].map((item) => item.course_id),
        ])
    )

    const individualCourses = progress.filter(
      (item) => groupsCoursesIds.indexOf(item.id) === -1 && item.id !== id
    )

    const sortedIndividualCourses = individualCourses
      .filter((item) => item.self_assignable !== 1)
      .sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1))

    const sortedAllCourses = progress
      .filter((item) => item.self_assignable === 1)
      .sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1))

    dispatch({
      type: types.SET_INDIVIDUAL_COURSES,
      courses: sortedIndividualCourses,
    })
    dispatch({
      type: types.SET_ALL_COURSES,
      courses: sortedAllCourses,
    })
  }
}

export const fetchGroupsCourses = () => {
  return (dispatch, getState) => {
    AxiosInstance.get(`/groups/courses`).then((data) => {
      if (Array.isArray(data)) {
        let groupCourses = {}
        let groupCoursesData = {}

        data.map((course) => {
          if (!groupCourses[course.group_id]) {
            groupCourses[course.group_id] = []
          }
          if (!groupCoursesData[course.group_id]) {
            groupCoursesData[course.group_id] = []
          }

          groupCourses[course.group_id].push(course)
          if (getState().courses.courses.length) {
            const currentCourse = getState().courses.courses.find(
              (item) => item.id === course.course_id
            )
            if (currentCourse) {
              groupCoursesData[course.group_id].push(
                currentCourse.name.toLowerCase().trim()
              )
            }
          }
        })

        const groups = getState().groups.groups.filter(
          (item) => item.type === 'course'
        )
        groups.map((item) => {
          if (groupCoursesData[item.id]) {
            item['courses'] = groupCoursesData[item.id].join('\t')
          } else {
            item['courses'] = ''
          }
        })

        dispatch({
          type: types.SET_GROUPS_COURSES_DATA,
          courses: groupCoursesData,
        })
        dispatch({ type: types.SET_GROUPS_COURSES, courses: groupCourses })
        dispatch({ type: types.SET_GROUPS_WITH_COURSES, groups: groups })
        dispatch({ type: types.SET_USER_GROUPS_COURSES, data })
        dispatch({ type: types.GROUPS_COURSES_LOADED })
        dispatch(setIndividualCourses())
      }
    })
  }
}

export const fetchAllGroupsCourses = () => {
  return (dispatch, getState) => {
    AxiosInstance.get(`/groups/courses/all`).then((data) => {
      if (Array.isArray(data)) {
        let groupCoursesAll = {}
        let groupCoursesDataAll = {}

        data.map((course) => {
          if (!groupCoursesAll[course.group_id]) {
            groupCoursesAll[course.group_id] = []
          }
          if (!groupCoursesDataAll[course.group_id]) {
            groupCoursesDataAll[course.group_id] = []
          }

          groupCoursesAll[course.group_id].push(course)
          if (getState().courses.courses.length) {
            const currentCourse = getState().courses.courses.find(
              (item) => item.id === course.course_id
            )
            if (currentCourse) {
              groupCoursesDataAll[course.group_id].push(
                currentCourse.name.toLowerCase().trim()
              )
            }
          }
        })

        const groups = getState().groups.groups.filter(
          (item) => item.type === 'course'
        )
        groups.map((item) => {
          if (groupCoursesDataAll[item.id]) {
            item['courses'] = groupCoursesDataAll[item.id].join('\t')
          } else {
            item['courses'] = ''
          }
        })

        dispatch({
          type: types.SET_GROUPS_COURSES_DATA_ALL,
          courses: groupCoursesDataAll,
        })
        dispatch({
          type: types.SET_GROUPS_COURSES_ALL,
          courses: groupCoursesAll,
        })
        dispatch({ type: types.SET_GROUPS_WITH_COURSES_ALL, groups: groups })
        dispatch({ type: types.SET_USER_GROUPS_COURSES_ALL, data })
        dispatch({ type: types.GROUPS_COURSES_LOADED })
        dispatch(setIndividualCourses())
      }
    })
  }
}

export const fetchTrainingGroups = () => {
  return (dispatch, getState) => {
    AxiosInstance.get(`/groups/trainings/courses`).then((data) => {
      if (Array.isArray(data)) {
        let groupCourses = {}
        let groupCoursesData = {}
        let groups = []
        const { trainings, ownedGroups } = getState().groups

        let manageableTrainings = trainings.filter(
          (item) => item.manageable && !item.owner
        )
        data.map((course) => {
          if (!groupCourses[course.group_id]) {
            groupCourses[course.group_id] = []
          }
          if (!groupCoursesData[course.group_id]) {
            groupCoursesData[course.group_id] = []
          }

          groupCourses[course.group_id].push(course)

          if (getState().courses.manageableCourses.length) {
            const currentCourse = getState().courses.manageableCourses.find(
              (item) => item.id === course.course_id
            )
            if (currentCourse) {
              groupCoursesData[course.group_id].push(
                currentCourse.name.toLowerCase().trim()
              )
            }
          }
        })

        if (getState().auth.user.access === 1) {
          groups = [...getState().groups.trainings]
        } else {
          groups = [...manageableTrainings, ...ownedGroups]
        }

        groups.map((item) => {
          if (groupCoursesData[item.id]) {
            item['courses'] = groupCoursesData[item.id].join('\t')
          } else {
            item['courses'] = ''
          }
        })

        groups.sort((a, b) =>
          a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
        )
        dispatch({ type: types.SET_TRAININGS_WITH_COURSES, trainings: groups })
      }
    })
  }
}

export const fetchUserTrainings = () => {
  return (dispatch, getState) => {
    dispatch({ type: types.SET_LOADING, value: true })
    AxiosInstance.get(`/groups/trainings`).then((data) => {
      if (Array.isArray(data)) {
        dispatch({ type: types.SET_USER_TRAINING, userTrainings: data })
        let manageableTrainings = []
        let ownedGroups = []
        let groups = []
        let trainings = []
        if (getState().auth.user.access === 1) {
          manageableTrainings = data.map((item) => item.group_id)
          trainings = getState().groups.groups.filter((item) =>
            manageableTrainings.includes(item.id)
          )
        } else {
          ownedGroups = getState().groups.ownedGroups
          manageableTrainings = data
            .filter((item) => item.manageable === true)
            .map((item) => item.group_id)
          groups = getState().groups.trainings.filter((item) =>
            manageableTrainings.includes(item.id)
          )
          trainings = [...groups, ...ownedGroups]
        }
        trainings.sort((a, b) => (a.name > b.name ? 1 : -1))

        dispatch({ type: types.SET_MANAGEABLE_TRAININGS, trainings })
        dispatch({ type: types.SET_LOADING, value: false })
      }
    })
  }
}

export const fetchOwnedGroups = () => {
  return (dispatch) => {
    AxiosInstance.get(`/groups/owned-groups`).then((data) => {
      if (Array.isArray(data)) {
        dispatch({ type: types.SET_OWNED_GROUPS, data })
      }
    })
  }
}

export const fetchGroupRoles = (id) => {
  return (dispatch) => {
    AxiosInstance.get(`/groups/${id}/roles`).then((roles) => {
      if (Array.isArray(roles)) {
        dispatch({
          type: types.SET_GROUP_ROLES,
          roles: roles.map((item) => item.role_id),
        })
      }
    })
  }
}

export const fetchRoleGroups = (id) => {
  return (dispatch) => {
    AxiosInstance.get(`/groups/${id}/role-groups`).then((roleGroups) => {
      if (Array.isArray(roleGroups)) {
        dispatch({
          type: types.SELECT_ROLE,
          roles: roleGroups.map((item) => item.role_id),
        })
      }
    })
  }
}

export const fetchGroupUsers = (id) => {
  return (dispatch) => {
    AxiosInstance.get(`/groups/${id}/users`).then((users) => {
      if (Array.isArray(users)) {
        dispatch({
          type: types.SET_GROUP_USERS,
          users: users.map((item) => item.user_id),
        })
      }
    })
  }
}

export const fetchTrainingUsers = (id) => {
  return (dispatch) => {
    AxiosInstance.get(`/groups/training/${id}/users`).then((users) => {
      if (Array.isArray(users)) {
        const assignedUsers = users
          .filter((item) => item.assigned)
          .map((item) => item.user_id)
        const manageableUsers = users
          .filter((item) => item.manageable)
          .map((item) => item.user_id)
        dispatch({
          type: types.SET_SELECTED_ASSIGNABLE_TRAINING_USERS,
          assignableTrainingUsers: assignedUsers,
        })
        dispatch({
          type: types.SET_SELECTED_MANAGEABLE_TRAINING_USERS,
          manageableTrainingUsers: manageableUsers,
        })
      }
    })
  }
}

export const fetchTrainingLocations = (id) => {
  return (dispatch) => {
    AxiosInstance.get(`/groups/training/${id}/locations`).then((stores) => {
      if (Array.isArray(stores)) {
        const assignedStores = stores
          .filter((item) => item.assigned)
          .map((item) => item.location_id)
        const manageableStores = stores
          .filter((item) => item.manageable)
          .map((item) => item.location_id)

        dispatch({
          type: types.SET_SELECTED_ASSIGNABLE_TRAINING_STORES,
          assignableTrainingStores: assignedStores,
        })
        dispatch({
          type: types.SET_SELECTED_MANAGEABLE_TRAINING_STORES,
          manageableTrainingStores: manageableStores,
        })
      }
    })
  }
}

export const fetchTrainingRoles = (id) => {
  return (dispatch) => {
    AxiosInstance.get(`/groups/training/${id}/roles`).then((roles) => {
      if (Array.isArray(roles)) {
        const assignedRoles = roles
          .filter((item) => item.assigned)
          .map((item) => item.role_id)
        const manageableRoles = roles
          .filter((item) => item.manageable)
          .map((item) => item.role_id)

        dispatch({
          type: types.SET_SELECTED_ASSIGNABLE_TRAINING_ROLES,
          assignableTrainingRoles: assignedRoles,
        })
        dispatch({
          type: types.SET_SELECTED_MANAGEABLE_TRAINING_ROLES,
          manageableTrainingRoles: manageableRoles,
        })
      }
    })
  }
}

export const fetchGroups = (query, shouldSetManagerAreas = true) => {
  return (dispatch, getState) => {
    dispatch({ type: types.SET_LOCATIONS_LOADING, value: true })
    AxiosInstance.get(`/groups/details${query || ''}`).then((groups) => {
      if (Array.isArray(groups)) {
        const locationAreas = groups.filter((area) => area.type === 'location')

        console.log(locationAreas, query, 'leart1036')

        if (shouldSetManagerAreas) {
          dispatch({
            type: SET_AREAS,
            areas: locationAreas,
          })
        }

        const newGroups = groups.slice()
        const { access } = getState().auth.user
        let learningPlanGroups = []

        groups.map((item) => {
          item.inactive = item.is_active === 1 ? false : true
          item.checklistGroupApproval = item.group_checklist_approval
        })
        const { enableCourseShowPastDueTrainings } = getState().courseConfig
        access === 1
          ? (learningPlanGroups = groups.filter(
              (item) => item.type === 'course' && item.show_in_learning_plan
            ))
          : enableCourseShowPastDueTrainings &&
            enableCourseShowPastDueTrainings === 1
          ? (learningPlanGroups = groups.filter(
              (item) => item.type === 'course' && item.show_in_learning_plan
            ))
          : (learningPlanGroups = groups.filter(
              (item) =>
                item.type === 'course' &&
                item.show_in_learning_plan &&
                !item.past_due
            ))

        dispatch({ type: types.SET_GROUPS, groups: newGroups })
        dispatch({
          type: types.SET_LOCATION_GROUPS,
          locationGroups: groups
            .filter((item) => item.type === 'location')
            .sort((a, b) =>
              a.name.trim().toLowerCase() > b.name.trim().toLowerCase() ? 1 : -1
            ),
        })
        dispatch({
          type: types.SET_ROLE_GROUP_GROUPS,
          roleGroups: groups
            .filter((item) => item.type === 'role')
            .sort((a, b) =>
              a.name.trim().toLowerCase() > b.name.trim().toLowerCase() ? 1 : -1
            ),
        })

        dispatch({
          type: types.SET_GROUPS_LEARNING_PLAN,
          groups: learningPlanGroups,
        })
        dispatch({ type: types.SET_GROUP_OWNER, owner: groups.owner })
        dispatch(setIndividualCourses())
        dispatch({ type: types.SET_LOCATIONS_LOADING, value: false })
      }
    })
  }
}

export const fetchAllGroups = () => {
  return (dispatch) => {
    dispatch({ type: types.SET_LOCATIONS_LOADING, value: true })
    AxiosInstance.get(`/groups/details/all`).then((groups) => {
      if (Array.isArray(groups)) {
        dispatch({
          type: types.SET_ALL_GROUPS,
          groups: groups
            .filter((item) => item.type === 'course')
            .sort((a, b) =>
              a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
            ),
        })
      }
    })
  }
}

export const fetchOrgGroups = () => {
  return (dispatch) => {
    AxiosInstance.get(`/groups/orgs`).then((data) =>
      dispatch({ type: types.SET_ORG_GROUPS, data })
    )
  }
}

export const fetchTrainings = () => {
  return (dispatch) => {
    AxiosInstance.get(`/groups/trainings/details`).then((groups) => {
      if (Array.isArray(groups)) {
        const newGroups = groups.slice()
        const orderGroups = newGroups.sort((a, b) => {
          let nameA = a.name.toUpperCase()
          let nameB = b.name.toUpperCase()

          if (nameA < nameB) return -1

          if (nameA > nameB) return 1

          return 0
        })
        dispatch({ type: types.SET_TRAININGS, trainings: orderGroups })
      }
    })
  }
}

export const deleteTraining = (id) => {
  return (dispatch, getState) => {
    let language = {}
    getState().language.language
      ? (language = getState().language.language.data)
      : null
    if (
      confirm(language.alerts ? language.alerts.delete_group_confirm : null)
    ) {
      const { trainingWithCourses, groups, learningPlanGroups } =
        getState().groups
      const trainingWithCoursesIndex = trainingWithCourses.findIndex(
        (item) => parseInt(item.id) === id
      )
      const index = groups.findIndex((item) => parseInt(item.id) === id)
      const learningPlanIndex = learningPlanGroups.findIndex(
        (item) => item.id === id
      )

      const newTrainings = [
        ...trainingWithCourses.slice(0, trainingWithCoursesIndex),
        ...trainingWithCourses.slice(trainingWithCoursesIndex + 1),
      ]

      const newGroups = [...groups.slice(0, index), ...groups.slice(index + 1)]

      const newLearningPlanGroups = [
        ...learningPlanGroups.slice(0, learningPlanIndex),
        ...learningPlanGroups.slice(learningPlanIndex + 1),
      ]

      AxiosInstance.delete(`/groups/${id}`).then(() => {
        dispatch({ type: types.SET_GROUPS, groups: newGroups })
        dispatch({
          type: types.SET_TRAININGS_WITH_COURSES,
          trainings: newTrainings,
        })
        dispatch({
          type: types.SET_GROUPS_LEARNING_PLAN,
          groups: newLearningPlanGroups,
        })
      })
    }
  }
}

export const deleteGroup = (id) => {
  return (dispatch, getState) => {
    let language = {}
    getState().language.language
      ? (language = getState().language.language.data)
      : null
    if (
      confirm(language.alerts ? language.alerts.delete_group_confirm : null)
    ) {
      const { groups } = getState().groups
      const index = groups.findIndex((item) => item.id === id)

      const newGroups = [...groups.slice(0, index), ...groups.slice(index + 1)]

      dispatch({ type: types.SET_GROUPS, groups: newGroups })

      AxiosInstance.delete(`/groups/${id}`).then(() => {
        dispatch(fetchTrainings())
      })
    }
  }
}

export const cloneGroup = (id) => {
  return (dispatch, getState) => {
    const { groupCloneStatus } = getState().groups

    console.log('id in clone group', id)

    if (groupCloneStatus) return

    dispatch({ type: types.GROUP_CLONE_STATUS, status: 'started' })
    AxiosInstance.post(`/groups/${id}/clone`)
      .then((data) => {
        dispatch({ type: types.GROUP_CLONED, data })
        dispatch({ type: types.GROUP_CLONE_STATUS, status: 'finished' })

        setTimeout(() => {
          dispatch({ type: types.GROUP_CLONE_STATUS, status: '' })
        }, 0)
      })
      .catch(() => dispatch({ type: types.GROUP_CLONE_STATUS, status: '' }))
  }
}

export const editGroup = (url) => {
  return (dispatch, getState) => {
    const urlArray = url.split('/')
    const id = urlArray
      .filter((item) => item !== '')
      .filter((item) => !isNaN(item))[0]

    if (id) {
      const { groups } = getState().groups
      const item = groups.find((item) => item.id == id)
      dispatch({ type: types.SET_GROUP, group: item })
    }
  }
}

export const toggleTags = (tags) => {
  return (dispatch) => {
    dispatch({ type: types.SET_TAG_DETAILS, tagDetails: tags.option })
    let result = tags.map((tag) => tag.option.value)

    dispatch({ type: types.SET_TAGS, tags: result })
  }
}

const mapGroupCourses = (data) => {
  if (Array.isArray(data)) {
    let groupCourses = {}
    let groupCoursesData = {}

    data.map((course) => {
      if (!groupCourses[course.group_id]) {
        groupCourses[course.group_id] = []
      }
      if (!groupCoursesData[course.group_id]) {
        groupCoursesData[course.group_id] = []
      }

      groupCourses[course.group_id].push(course)
    })

    return groupCourses
  }
}

export const updateGroup = () => {
  return (dispatch, getState) => {
    const { id, name, show_in_learning_plan } = getState().groups.group
    console.log(id, name, 'update group')
    const {
      groups,
      selectedCourses,
      selectedCoursesWithPosition,
      assignableTrainingUsers,
      manageableTrainingUsers,
      assignableTrainingLocations,
      manageableTrainingLocations,
      assignableTrainingStores,
      manageableTrainingStores,
      assignableTrainingRoles,
      manageableTrainingRoles,
      assignableTrainingRoleGroups,
      assignableTrainingLocationGroups,
      manageableTrainingLocationGroups,
      startDate,
      endDate,
      duration,
      datesDisabled,
      hasDate,
      hasDuration,
      doNotAssign,
      automaticEnrollment,
      pinToNavbar,
      pinToNavbarDevelopment,
      enableReorder,
      trainingWithCourses,
      hasExpireDate,
      expireDate,
      reassignDate,
      expirePeriod,
      expirePrior,
      groupsCourses,
      learningPlanGroups,
      inactive,
      equivalentGroup,
      setUserNotAssignedFromRole,
    } = getState().groups

    const tags = getState().groups.tags

    const index = groups.findIndex((item) => parseInt(item.id) === id)
    const trainingIndex = trainingWithCourses.findIndex(
      (item) => parseInt(item.id) === id
    )
    const learningPlanIndex = learningPlanGroups.findIndex(
      (item) => parseInt(item.id) === id
    )

    let selectedUsers = []
    let selectedLocations = []
    let selectedStores = []
    let selectedRoles = []
    let selectedAssociates = []
    let selectedRoleGroups = []
    let selectUsersNotAssignedFromRole = []

    if (assignableTrainingUsers.length) {
      assignableTrainingUsers.map((item) => {
        const assignableItem = {
          user_id: item,
          assigned: true,
          manageable: false,
        }
        selectedUsers.push(assignableItem)
      })
    }

    if (manageableTrainingUsers.length) {
      manageableTrainingUsers.map((item) => {
        const currentUser = selectedUsers.find(
          (selectedItem) => selectedItem.user_id === item
        )
        if (currentUser) {
          currentUser.manageable = true
        } else {
          const manageableItem = {
            user_id: item,
            assigned: false,
            manageable: true,
          }
          selectedUsers.push(manageableItem)
        }
      })
    }

    if (assignableTrainingLocations.length) {
      assignableTrainingLocations.map((item) => {
        const assignableItem = {
          location_id: item,
          assigned: true,
          manageable: false,
        }
        selectedLocations.push(assignableItem)
      })
    }

    if (setUserNotAssignedFromRole.length) {
      setUserNotAssignedFromRole.map((item) => {
        const assignableItem = {
          user_id: item,
          assigned: true,
          manageable: false,
        }
        selectUsersNotAssignedFromRole.push(assignableItem)
      })
    }

    if (manageableTrainingLocations.length) {
      manageableTrainingLocations.map((item) => {
        const currentLocation = selectedLocations.find(
          (selectedItem) => selectedItem.location_id === item
        )
        if (currentLocation) {
          currentLocation.manageable = true
        } else {
          const manageableItem = {
            location_id: item,
            assigned: false,
            manageable: true,
          }
          selectedLocations.push(manageableItem)
        }
      })
    }

    if (assignableTrainingStores.length) {
      assignableTrainingStores.map((item) => {
        const assignableItem = {
          location_id: item,
          assigned: true,
          manageable: false,
        }
        selectedStores.push(assignableItem)
      })
    }

    if (assignableTrainingRoleGroups.length) {
      assignableTrainingRoleGroups.map((item) => {
        const assignableItem = {
          associate_id: item,
          assigned: true,
          manageable: false,
        }
        selectedRoleGroups.push(assignableItem)
      })
    }

    if (manageableTrainingStores.length) {
      manageableTrainingStores.map((item) => {
        const currentStore = selectedStores.find(
          (selectedItem) => selectedItem.location_id === item
        )
        if (currentStore) {
          currentStore.manageable = true
        } else {
          const manageableItem = {
            location_id: item,
            assigned: false,
            manageable: true,
          }
          selectedStores.push(manageableItem)
        }
      })
    }

    if (assignableTrainingRoles.length) {
      assignableTrainingRoles.map((item) => {
        const assignableItem = {
          role_id: item,
          assigned: true,
          manageable: false,
        }
        selectedRoles.push(assignableItem)
      })
    }

    if (manageableTrainingRoles.length) {
      manageableTrainingRoles.map((item) => {
        const currentRole = selectedRoles.find(
          (selectedItem) => selectedItem.role_id === item
        )
        if (currentRole) {
          currentRole.manageable = true
        } else {
          const manageableItem = {
            role_id: item,
            assigned: false,
            manageable: true,
          }
          selectedRoles.push(manageableItem)
        }
      })
    }

    if (assignableTrainingLocationGroups.length) {
      assignableTrainingLocationGroups.map((item) => {
        const assignableItem = {
          associate_id: item,
          assigned: true,
          manageable: false,
        }
        selectedAssociates.push(assignableItem)
      })
    }

    if (manageableTrainingLocationGroups.length) {
      manageableTrainingLocationGroups.map((item) => {
        const currentAssociate = selectedAssociates.find(
          (selectedItem) => selectedItem.associate_id === item
        )
        if (currentAssociate) {
          currentAssociate.manageable = true
        } else {
          const manageableItem = {
            associate_id: item,
            assigned: false,
            manageable: true,
          }
          selectedAssociates.push(manageableItem)
        }
      })
    }

    AxiosInstance.put(`/groups/${id}`, {
      name,
      type: 'course',
      show_in_learning_plan,
      users: JSON.stringify(selectedUsers),
      courses: JSON.stringify(selectedCourses),
      roles: JSON.stringify(selectedRoles),
      roleGroups: JSON.stringify(selectedRoleGroups),
      groups: JSON.stringify(selectedAssociates),
      locations: JSON.stringify(selectedStores),
      usersNotAssigned: JSON.stringify(selectUsersNotAssignedFromRole),
      start_date:
        hasDate && startDate
          ? moment(startDate).format('YYYY-MM-DD HH:MM:SS')
          : null,
      end_date:
        hasDate && endDate
          ? moment(endDate).format('YYYY-MM-DD HH:MM:SS')
          : null,
      duration:
        !hasDuration || parseInt(duration) === 0 ? null : parseInt(duration),
      // has_expire_date: hasExpireDate ? 1 : 0,
      expire_time: hasExpireDate
        ? expireDate
          ? expireDate + expirePeriod
          : null
        : null,
      expire_reassign_time: hasExpireDate
        ? reassignDate
          ? reassignDate + expirePrior
          : null
        : null,
      tags: JSON.stringify(tags),
      dates_disabled: datesDisabled ? 1 : 0,
      assignable: doNotAssign ? -1 : 1,
      automatic_enrollment: automaticEnrollment ? 1 : 0,
      pin_to_navbar: pinToNavbar ? 1 : 0,
      pin_to_navbar_development: pinToNavbarDevelopment ? 1 : 0,
      enable_reorder: enableReorder ? 1 : 0,
      is_active: inactive === true ? -1 : 1,
      coursesWithPosition: selectedCoursesWithPosition,
      equivalent_id: equivalentGroup ? equivalentGroup : null,
    }).then((group) => {
      if (group) {
        group.id = parseInt(group.id)
        group.assignable = parseInt(group.assignable)
        group.automatic_enrollment = parseInt(group.automatic_enrollment)
        group.show_in_learning_plan = parseInt(group.show_in_learning_plan)
        group.duration = parseInt(group.duration)
        group.dates_disabled = parseInt(group.dates_disabled)
        group.tags ? (group.tags = JSON.parse(group.tags)) : null
        group.inactive = parseInt(group.is_active) === 1 ? false : true
        group.equivalentGroup = parseInt(group.equivalent_id)
        group.has_expire_date = parseInt(group.has_expire_date)
        group.expire_time = parseInt(group.expireDate)
        group.expire_reassign_time = parseInt(group.reassignDate)

        const newGroups = [
          ...groups.slice(0, index),
          group,
          ...groups.slice(index + 1),
        ]

        const newTrainingWithCourses = [
          ...trainingWithCourses.slice(0, trainingIndex),
          group,
          ...trainingWithCourses.slice(trainingIndex + 1),
        ]

        const newLearningPlanGroups = [
          ...learningPlanGroups.slice(0, learningPlanIndex),
          group,
          ...learningPlanGroups.slice(learningPlanIndex + 1),
        ]

        let newGroupsCourses = []

        if (selectedCourses.length) {
          selectedCourses.map((item) => {
            newGroupsCourses.push({ course_id: item, group_id: group.id })
          })
        }

        groupsCourses[group.id] = newGroupsCourses

        dispatch({
          type: types.SET_GROUPS_LEARNING_PLAN,
          groups: newLearningPlanGroups,
        })
        dispatch({ type: types.SET_GROUPS_COURSES, courses: groupsCourses })
        dispatch({
          type: types.SET_TRAININGS_WITH_COURSES,
          trainings: [...new Set(newTrainingWithCourses)],
        })
        dispatch({ type: types.SET_GROUPS, groups: [...new Set(newGroups)] })
        dispatch({ type: types.SET_TAGS, tags: null })
        dispatch(fetchGroupsCourses())
      }
    })
  }
}

export const fetchRoles = () => {
  return (dispatch) => {
    AxiosInstance.get('/roles').then((roles) => {
      if (roles && Array.isArray(roles)) {
        dispatch({ type: types.SET_ROLES, roles })
      }
    })
  }
}

export const toggleAssignableGroupUser = (id) => {
  return (dispatch, getState) => {
    const { assignableTrainingUsers } = getState().groups

    const index = assignableTrainingUsers.indexOf(id)

    let groupUsers = []

    if (index !== -1) {
      groupUsers = [
        ...assignableTrainingUsers.slice(0, index),
        ...assignableTrainingUsers.slice(index + 1),
      ]
    } else {
      groupUsers = [...assignableTrainingUsers, id]
    }

    dispatch({
      type: types.SET_SELECTED_ASSIGNABLE_TRAINING_USERS,
      assignableTrainingUsers: groupUsers,
    })
  }
}

export const toggleManageableGroupUser = (id) => {
  return (dispatch, getState) => {
    const { manageableTrainingUsers } = getState().groups

    const index = manageableTrainingUsers.indexOf(id)

    let groupUsers = []

    if (index !== -1) {
      groupUsers = [
        ...manageableTrainingUsers.slice(0, index),
        ...manageableTrainingUsers.slice(index + 1),
      ]
    } else {
      groupUsers = [...manageableTrainingUsers, id]
    }

    dispatch({
      type: types.SET_SELECTED_MANAGEABLE_TRAINING_USERS,
      manageableTrainingUsers: groupUsers,
    })
  }
}

export const toggleAssignableGroupLocation = (id) => {
  return (dispatch, getState) => {
    const { assignableTrainingLocations } = getState().groups

    const index = assignableTrainingLocations.indexOf(id)
    let groupLocations = []

    if (index !== -1) {
      groupLocations = [
        ...assignableTrainingLocations.slice(0, index),
        ...assignableTrainingLocations.slice(index + 1),
      ]
    } else {
      groupLocations = [...assignableTrainingLocations, id]
    }

    dispatch({
      type: types.SET_SELECTED_ASSIGNABLE_TRAINING_LOCATIONS,
      assignableTrainingLocations: groupLocations,
    })
  }
}

export const toggleManageableGroupLocation = (id) => {
  return (dispatch, getState) => {
    const { manageableTrainingLocations } = getState().groups

    const index = manageableTrainingLocations.indexOf(id)

    let groupLocations = []

    if (index !== -1) {
      groupLocations = [
        ...manageableTrainingLocations.slice(0, index),
        ...manageableTrainingLocations.slice(index + 1),
      ]
    } else {
      groupLocations = [...manageableTrainingLocations, id]
    }

    dispatch({
      type: types.SET_SELECTED_MANAGEABLE_TRAINING_LOCATIONS,
      manageableTrainingLocations: groupLocations,
    })
  }
}

export const toggleAssignableRoleGroup = (id) => {
  return (dispatch, getState) => {
    const { assignableTrainingRoleGroups } = getState().groups
    const index = assignableTrainingRoleGroups.indexOf(id)

    let roleGroups = []

    if (index !== -1) {
      roleGroups = [
        ...assignableTrainingRoleGroups.slice(0, index),
        ...assignableTrainingRoleGroups.slice(index + 1),
      ]
    } else {
      roleGroups = [...assignableTrainingRoleGroups, id]
    }

    dispatch({
      type: types.SET_SELECTED_ASSIGNABLE_TRAINING_ROLE_GROUPS,
      assignableTrainingRoleGroups: roleGroups,
    })
  }
}

export const toggleManageableRoleGroup = (id) => {
  return (dispatch, getState) => {
    const { manageableTrainingRoleGroups } = getState().groups

    const index = manageableTrainingRoleGroups.indexOf(id)

    let roleGroups = []

    if (index !== -1) {
      roleGroups = [
        ...manageableTrainingRoleGroups.slice(0, index),
        ...manageableTrainingRoleGroups.slice(index + 1),
      ]
    } else {
      roleGroups = [...manageableTrainingRoleGroups, id]
    }

    dispatch({
      type: types.SET_SELECTED_MANAGEABLE_TRAINING_LOCATIONS,
      manageableTrainingRoleGroups: roleGroups,
    })
  }
}

export const toggleAssignableGroupStores = (id) => {
  return (dispatch, getState) => {
    const { assignableTrainingStores } = getState().groups

    const index = assignableTrainingStores.indexOf(id)
    let groupStores = []

    if (index !== -1) {
      groupStores = [
        ...assignableTrainingStores.slice(0, index),
        ...assignableTrainingStores.slice(index + 1),
      ]
    } else {
      groupStores = [...assignableTrainingStores, id]
    }

    dispatch({
      type: types.SET_SELECTED_ASSIGNABLE_TRAINING_STORES,
      assignableTrainingStores: groupStores,
    })
  }
}

export const toggleManageableGroupStores = (id) => {
  return (dispatch, getState) => {
    const { manageableTrainingStores } = getState().groups

    const index = manageableTrainingStores.indexOf(id)

    let groupStores = []

    if (index !== -1) {
      groupStores = [
        ...manageableTrainingStores.slice(0, index),
        ...manageableTrainingStores.slice(index + 1),
      ]
    } else {
      groupStores = [...manageableTrainingStores, id]
    }

    dispatch({
      type: types.SET_SELECTED_MANAGEABLE_TRAINING_STORES,
      manageableTrainingStores: groupStores,
    })
  }
}

export const toggleAssignableLocationGroups = (id) => {
  return (dispatch, getState) => {
    const { assignableTrainingLocationGroups } = getState().groups
    const index = assignableTrainingLocationGroups.indexOf(id)

    let groupAssociates = []

    if (index !== -1) {
      groupAssociates = [
        ...assignableTrainingLocationGroups.slice(0, index),
        ...assignableTrainingLocationGroups.slice(index + 1),
      ]
    } else {
      groupAssociates = [...assignableTrainingLocationGroups, id]
    }

    dispatch({
      type: types.SET_SELECTED_ASSIGNABLE_TRAINING_LOCATION_GROUPS,
      assignableTrainingLocationGroups: groupAssociates,
    })
  }
}

export const toggleManageableLocationGroups = (id) => {
  return (dispatch, getState) => {
    const { manageableTrainingLocationGroups } = getState().groups

    const index = manageableTrainingLocationGroups.indexOf(id)

    let groupAssociates = []

    if (index !== -1) {
      groupAssociates = [
        ...manageableTrainingLocationGroups.slice(0, index),
        ...manageableTrainingLocationGroups.slice(index + 1),
      ]
    } else {
      groupAssociates = [...manageableTrainingLocationGroups, id]
    }

    dispatch({
      type: types.SET_SELECTED_MANAGEABLE_TRAINING_LOCATION_GROUPS,
      manageableTrainingLocationGroups: groupAssociates,
    })
  }
}

export const toggleAssignableGroupRoles = (id) => {
  return (dispatch, getState) => {
    const { assignableTrainingRoles } = getState().groups

    const index = assignableTrainingRoles.indexOf(id)

    let groupRoles = []

    if (index !== -1) {
      groupRoles = [
        ...assignableTrainingRoles.slice(0, index),
        ...assignableTrainingRoles.slice(index + 1),
      ]
    } else {
      groupRoles = [...assignableTrainingRoles, id]
    }

    dispatch({
      type: types.SET_SELECTED_ASSIGNABLE_TRAINING_ROLES,
      assignableTrainingRoles: groupRoles,
    })
  }
}

export const b = (id) => {
  return (dispatch, getState) => {
    const { manageableTrainingRoles } = getState().groups

    const index = manageableTrainingRoles.indexOf(id)

    let groupRoles = []

    if (index !== -1) {
      groupRoles = [
        ...manageableTrainingRoles.slice(0, index),
        ...manageableTrainingRoles.slice(index + 1),
      ]
    } else {
      groupRoles = [...manageableTrainingRoles, id]
    }

    dispatch({
      type: types.SET_SELECTED_MANAGEABLE_TRAINING_ROLES,
      manageableTrainingRoles: groupRoles,
    })
  }
}

export const toggleAllAssignableUsers = () => {
  return (dispatch, getState) => {
    const { users } = getState().users
    const { selectedUsers } = getState().groups

    let groupUsers = []

    if (users.length !== selectedUsers.length) {
      groupUsers = users.map((item) => item.id)
    }

    dispatch({ type: types.SET_GROUP_USERS, users: groupUsers })
    dispatch({
      type: types.SET_SELECTED_ASSIGNABLE_TRAINING_USERS,
      assignableTrainingUsers: groupUsers,
    })
  }
}

export const toggleAllManageableUsers = () => {
  return (dispatch, getState) => {
    const { users } = getState().auth.user
    const { selectedUsers } = getState().groups

    let groupUsers = []

    if (users.length !== selectedUsers.length) {
      groupUsers = users.map((item) => item.id)
    }

    dispatch({ type: types.SET_GROUP_USERS, users: groupUsers })
    dispatch({
      type: types.SET_SELECTED_MANAGEABLE_TRAINING_USERS,
      manageableTrainingUsers: groupUsers,
    })
  }
}

export const fetchLocations = () => {
  return (dispatch) => {
    AxiosInstance.get('/stores').then((locations) => {
      if (locations && Array.isArray(locations)) {
        dispatch({ type: types.SET_LOCATIONS, locations })
      }
    })
  }
}

export const fetchCoreGroupCourses = () => {
  return (dispatch) => {
    AxiosInstance.get('groups/core-groups').then((groups) => {
      dispatch({
        type: types.SET_CORE_GROUP_COURSES,
        groups,
      })
    })
  }
}

export const updateGroupLocationGroup = () => {
  return (dispatch, getState) => {
    const { id, name } = getState().groups.group
    const {
      groups,
      selectedStores,
      selectedLocations,
      assignableTrainingLocationGroups,
      inactive,
    } = getState().groups
    const index = groups.findIndex((item) => parseInt(item.id) === id)

    AxiosInstance.put(`/groups/${id}`, {
      name,
      type: 'location',
      locations: JSON.stringify(selectedStores),
      groups: JSON.stringify(assignableTrainingLocationGroups),
      is_active: inactive === true ? -1 : 1,
    }).then((group) => {
      if (group) {
        const newGroups = [
          ...groups.slice(0, index),
          group,
          ...groups.slice(index + 1),
        ]

        dispatch({ type: types.SET_GROUPS, groups: [...new Set(newGroups)] })
      }
    })
  }
}

export const updateRoleGroup = () => {
  return (dispatch, getState) => {
    const { id, name } = getState().groups.group
    const { groups, assignableTrainingRoleGroups, selectedRoles, inactive } =
      getState().groups
    const index = groups.findIndex((item) => parseInt(item.id) === id)

    AxiosInstance.put(`/groups/${id}`, {
      name,
      type: 'role',
      roles: JSON.stringify(selectedRoles),
      roleGroups: JSON.stringify(assignableTrainingRoleGroups),
      is_active: inactive === true ? -1 : 1,
    }).then((group) => {
      dispatch(fetchGroups())
      if (group) {
        const newGroups = [
          ...groups.slice(0, index),
          group,
          ...groups.slice(index + 1),
        ]

        // dispatch({ type: types.SET_ROLES, roles: [...new Set(newGroups)] })
      }
    })
  }
}

export const createLocationsGroup = () => {
  return (dispatch, getState) => {
    const { name } = getState().groups.group
    const {
      groups,
      selectedLocations,
      selectedStores,
      assignableTrainingLocationGroups,
      inactive,
    } = getState().groups

    AxiosInstance.post('/groups', {
      name,
      type: 'location',
      locations: JSON.stringify(selectedStores),
      groups: JSON.stringify(assignableTrainingLocationGroups),
      is_active: inactive === true ? -1 : 1,
    }).then((group) => {
      if (group) {
        dispatch({ type: types.SET_GROUPS, groups: [...groups, group] })
      }
    })
  }
}

export const createRoleGroup = () => {
  return (dispatch, getState) => {
    const { name } = getState().groups.group
    const {
      groups,
      selectedLocations,
      selectedRoles,
      assignableTrainingLocationGroups,
      inactive,
    } = getState().groups

    AxiosInstance.post('/groups', {
      name,
      type: 'role',
      roles: JSON.stringify(selectedRoles),
      groups: JSON.stringify(assignableTrainingLocationGroups),
      is_active: inactive === true ? -1 : 1,
    }).then((group) => {
      if (group) {
        dispatch({ type: types.SET_GROUPS, groups: [...groups, group] })
      }
    })
  }
}

export const toggleLocation = (id) => {
  return (dispatch, getState) => {
    const { selectedLocations } = getState().groups

    const index = selectedLocations.indexOf(id)

    let groupLocations = []

    if (index !== -1) {
      groupLocations = [
        ...selectedLocations.slice(0, index),
        ...selectedLocations.slice(index + 1),
      ]
    } else {
      groupLocations = [...selectedLocations, id]
    }

    dispatch({ type: types.SET_GROUP_LOCATIONS, locations: groupLocations })
  }
}

export const toggleStore = (id) => {
  return (dispatch, getState) => {
    const { selectedStores } = getState().groups

    const index = selectedStores.indexOf(id)

    let groupStores = []

    if (index !== -1) {
      groupStores = [
        ...selectedStores.slice(0, index),
        ...selectedStores.slice(index + 1),
      ]
    } else {
      groupStores = [...selectedStores, id]
    }

    dispatch({ type: types.SET_GROUP_STORES, stores: groupStores })
  }
}

export const toggleRole = (id) => {
  return (dispatch, getState) => {
    const { selectedRoles } = getState().groups
    const index = selectedRoles.indexOf(id)

    let groupRoles = []

    if (index !== -1) {
      groupRoles = [
        ...selectedRoles.slice(0, index),
        ...selectedRoles.slice(index + 1),
      ]
    } else {
      groupRoles = [...selectedRoles, id]
    }

    dispatch({ type: types.SET_GROUP_ROLES, roles: groupRoles })
  }
}

export const toggleRoleGroup = (id) => {
  return (dispatch, getState) => {
    const { selectedRoleGroups } = getState().groups

    const index = selectedRoleGroups.indexOf(id)

    let groupRoles = []

    if (index !== -1) {
      groupRoles = [
        ...selectedRoleGroups.slice(0, index),
        ...selectedRoleGroups.slice(index + 1),
      ]
    } else {
      groupRoles = [...selectedRoleGroups, id]
    }

    dispatch({ type: types.SET_ROLE_GROUPS, roleGroups: groupRoles })
  }
}

export const fetchGroupLocations = (groupId) => {
  return (dispatch) => {
    AxiosInstance.get(`/groups/${groupId}/locations`).then((locations) => {
      if (Array.isArray(locations)) {
        dispatch({
          type: types.SET_GROUP_STORES,
          stores: locations.map((item) => item.location_id),
        })
      }
    })
  }
}

export const fetchGroupAssociates = (groupId) => {
  return (dispatch) => {
    AxiosInstance.get(`/groups/${groupId}/associates`).then((associates) => {
      if (Array.isArray(associates)) {
        const assignedLocationGroups = associates
          .filter((item) => item.assigned && item.associateType === 'location')
          .map((item) => item.associate_id)
        const manageableLocationGroups = associates
          .filter(
            (item) => item.manageable && item.associateType === 'location'
          )
          .map((item) => item.associate_id)

        const assignableTrainingRoleGroups = associates
          .filter((item) => item.assigned && item.associateType === 'role')
          .map((item) => item.associate_id)

        dispatch({
          type: types.SET_SELECTED_ASSIGNABLE_TRAINING_ROLE_GROUPS,
          assignableTrainingRoleGroups: assignableTrainingRoleGroups,
        })

        // const manageableRoleGroups = associates
        // 	.filter((item) => item.manageable && item.associateType === 'role')
        // 	.map((item) => item.associate_id)

        // dispatch({
        // 	type: types.SET_SELECTED_MANAGEABLE_TRAINING_ROLE_GROUPS,
        // 	manageableTrainingRoleGroups: manageableRoleGroups,
        // })

        dispatch({
          type: types.SET_SELECTED_ASSIGNABLE_TRAINING_LOCATION_GROUPS,
          assignableTrainingLocationGroups: assignedLocationGroups,
        })
        dispatch({
          type: types.SET_SELECTED_MANAGEABLE_TRAINING_LOCATION_GROUPS,
          manageableTrainingLocationGroups: manageableLocationGroups,
        })

        dispatch({
          type: types.SET_GROUP_ASSOCIATES,
          groups: associates.map((item) => item.associate_id),
        })
      }
    })
  }
}

export const toggleGroupAssociate = (id) => {
  return (dispatch, getState) => {
    const { selectedGroups } = getState().groups

    const index = selectedGroups.indexOf(id)

    let groupAssociates = []

    if (index !== -1) {
      groupAssociates = [
        ...selectedGroups.slice(0, index),
        ...selectedGroups.slice(index + 1),
      ]
    } else {
      groupAssociates = [...selectedGroups, id]
    }

    dispatch({ type: types.SET_GROUP_ASSOCIATES, groups: groupAssociates })
  }
}

export const setGroupIndex = (index) => {
  return (dispatch) => {
    dispatch(setCourseIndex(null))
    dispatch({ type: types.SET_GROUP_INDEX, index })
  }
}

export const reorderGroups = (nextIndex) => {
  return (dispatch, getState) => {
    const { learningPlanGroups, groupIndex } = getState().groups

    const reduceGroups = [
      ...learningPlanGroups.slice(0, groupIndex),
      ...learningPlanGroups.slice(groupIndex + 1),
    ]

    const newGroups = [
      ...reduceGroups.slice(0, nextIndex),
      learningPlanGroups[groupIndex],
      ...reduceGroups.slice(nextIndex),
    ]

    dispatch(setGroupIndex(nextIndex))
    dispatch({ type: types.SET_GROUPS_LEARNING_PLAN, groups: newGroups })
  }
}

export const reorderCourses = (nextIndex) => {
  return (dispatch, getState) => {
    const { courseIndex, groupsCourses, groupIndex, learningPlanGroups } =
      getState().groups
    const { id } = learningPlanGroups[groupIndex]
    const courses = groupsCourses[id]

    const reduceCourses = [
      ...courses.slice(0, courseIndex),
      ...courses.slice(courseIndex + 1),
    ]

    const newCourses = [
      ...reduceCourses.slice(0, nextIndex),
      courses[courseIndex],
      ...reduceCourses.slice(nextIndex),
    ]

    const newGroupsCourses = {
      ...groupsCourses,
      [id]: newCourses,
    }

    dispatch(setCourseIndex(nextIndex))
    dispatch({ type: types.SET_GROUPS_COURSES, courses: newGroupsCourses })
  }
}

export const reorderIndividualCourses = (nextIndex) => {
  return (dispatch, getState) => {
    const { courseIndex, individualCourses } = getState().groups

    const reduceCourses = [
      ...individualCourses.slice(0, courseIndex),
      ...individualCourses.slice(courseIndex + 1),
    ]

    const newCourses = [
      ...reduceCourses.slice(0, nextIndex),
      individualCourses[courseIndex],
      ...reduceCourses.slice(nextIndex),
    ]

    dispatch(setCourseIndex(nextIndex))
    dispatch({ type: types.SET_INDIVIDUAL_COURSES, courses: newCourses })
  }
}

export const reorderItems = (nextIndex) => {
  return (dispatch, getState) => {
    const { courseIndex, groupIndex } = getState().groups

    if (groupIndex === null) {
      return dispatch(reorderIndividualCourses(nextIndex))
    } else if (courseIndex !== null) {
      return dispatch(reorderCourses(nextIndex))
    }

    return dispatch(reorderGroups(nextIndex))
  }
}

export const saveGroupOrder = () => {
  return (dispatch, getState) => {
    dispatch(present())
    dispatch(toggleGroupOrder('saving'))

    const { individualCourses, groupsCourses, learningPlanGroups } =
      getState().groups

    AxiosInstance.post('/groups/reorder', {
      groups: JSON.stringify(learningPlanGroups),
      courses: JSON.stringify(groupsCourses),
      individualCourses: JSON.stringify(individualCourses),
    })
  }
}

export const toggleGroupOrder = (mode) => {
  return (dispatch, getState) => {
    const { groupOrderShowing } = getState().groups

    if (!groupOrderShowing) {
      dispatch(present())
    } else if (mode !== 'saving') {
      dispatch(undo())
    }

    dispatch(setGroupIndex(0))
    dispatch({ type: types.TOGGLE_GROUP, isShowing: !groupOrderShowing })
  }
}

export const setComplianceGroups = (complianceGroups) => ({
  type: types.SET_COMPLIANCE_GROUPS,
  payload: complianceGroups,
})

export const setInitialComplianceGroups = (complianceGroups) => ({
  type: types.SET_INITIAL_COMPLIANCE_GROUPS,
  payload: complianceGroups,
})

export const setComplianceGroupIndex = (index) => {
  return (dispatch) => {
    // dispatch(setCourseIndex(null));
    dispatch({ type: types.SET_COMPLIANCE_GROUP_INDEX, index })
  }
}

export const toggleComplianceGroupOrder = (mode) => {
  return (dispatch, getState) => {
    const { complianceGroupOrderShowing, initialComplianceGroups } =
      getState().groups

    if (!complianceGroupOrderShowing) {
      dispatch(present())
    } else if (mode !== 'saving') {
      dispatch(undo())
      dispatch(setComplianceGroups(initialComplianceGroups))
    }

    dispatch(setComplianceGroupIndex(0))
    dispatch({
      type: types.TOGGLE_COMPLIANCE_GROUP,
      isShowing: !complianceGroupOrderShowing,
    })
  }
}

export const reorderComplianceGroups = (nextIndex) => {
  return (dispatch, getState) => {
    const { complianceGroups, complianceGroupIndex } = getState().groups

    const reduceGroups = [
      ...complianceGroups.slice(0, complianceGroupIndex),
      ...complianceGroups.slice(complianceGroupIndex + 1),
    ]

    const newGroups = [
      ...reduceGroups.slice(0, nextIndex),
      complianceGroups[complianceGroupIndex],
      ...reduceGroups.slice(nextIndex),
    ]

    dispatch(setComplianceGroupIndex(nextIndex))
    dispatch(setComplianceGroups(newGroups))
  }
}

export const saveComplianceGroupOrder = () => {
  return (dispatch, getState) => {
    const { complianceGroupOrderShowing } = getState().groups

    dispatch(present())
    dispatch(toggleGroupOrder('saving'))
    dispatch({
      type: types.TOGGLE_COMPLIANCE_GROUP,
      isShowing: !complianceGroupOrderShowing,
    })

    const { complianceGroups } = getState().groups
    dispatch(setInitialComplianceGroups(complianceGroups))

    AxiosInstance.post('/groups/reorder/compliance-groups', {
      groups: JSON.stringify(complianceGroups),
    })
  }
}

export const uploadGroups = (event) => {
  return (dispatch, getState) => {
    event.preventDefault()

    const { uploadGroupStatus } = getState().groups

    if (uploadGroupStatus === 'started') return

    const nodes = event.target.elements
    const fileInput = [].filter.call(nodes, (item) => item.type === 'file')[0]

    const file = fileInput.files[0]

    const data = new FormData()
    data.append('file', file)

    let language = {}
    getState().language.language
      ? (language = getState().language.language.data)
      : null
    if (!file) {
      alert(language.alerts ? language.alerts.select_file : null)
      return
    }

    dispatch({ type: types.UPLOAD_GROUP_STATUS, status: 'started' })

    axios
      .post(
        `${clientBaseUrl()}/groups/locations/import?token=${accessToken()}`,
        data,
        {
          onUploadProgress: (progressEvent) => {
            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            )

            dispatch({ type: types.UPLOAD_GROUP_PERCENT, percent })
          },
        }
      )
      .then(() => {
        dispatch({ type: types.UPLOAD_GROUP_STATUS, status: '' })
        dispatch({ type: types.UPLOAD_GROUP_PERCENT, percent: 0 })

        alert(
          language.alerts ? language.alerts.group_imported_successfully : null
        )
      })
  }
}

export const uploadMultiLocationGroups = (event) => {
  return (dispatch, getState) => {
    event.preventDefault()

    const { uploadGroupStatus } = getState().groups

    if (uploadGroupStatus === 'started') return

    const nodes = event.target.elements
    const fileInput = [].filter.call(nodes, (item) => item.type === 'file')[0]

    const file = fileInput.files[0]

    const data = new FormData()
    data.append('file', file)

    let language = {}
    getState().language.language
      ? (language = getState().language.language.data)
      : null
    if (!file) {
      alert(language.alerts ? language.alerts.select_file : null)
      return
    }

    dispatch({ type: types.UPLOAD_GROUP_STATUS, status: 'started' })

    axios
      .post(
        `${clientBaseUrl()}/groups/multiple/import?token=${accessToken()}`,
        data,
        {
          onUploadProgress: (progressEvent) => {
            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            )

            dispatch({ type: types.UPLOAD_GROUP_PERCENT, percent })
          },
        }
      )
      .then(() => {
        dispatch({ type: types.UPLOAD_GROUP_STATUS, status: '' })
        dispatch({ type: types.UPLOAD_GROUP_PERCENT, percent: 0 })

        // alert(language.alerts ? language.alerts.group_imported_successfully : null)
        alert('Groups of locations uploaded successfully!')
      })
  }
}

export const uploadGroupsCompletion = (event) => {
  return (dispatch, getState) => {
    event.preventDefault()

    const { uploadStatus } = getState().groups
    if (uploadStatus === 'started') return

    const nodes = event.target.elements
    const fileInput = [].filter.call(nodes, (item) => item.type === 'file')[0]
    const file = fileInput.files[0]
    const data = new FormData()

    data.append('file', file)

    let language = {}
    getState().language.language
      ? (language = getState().language.language.data)
      : null
    if (!file) {
      alert(language.alerts ? language.alerts.select_file : null)
      return
    }

    dispatch({ type: types.UPLOAD_GROUP_STATUS, status: 'started' })

    axios
      .post(
        `${clientBaseUrl()}/users/import-group-progress?token=${accessToken()}`,
        data,
        {
          onUploadProgress: (progressEvent) => {
            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            )

            dispatch({ type: types.UPLOAD_GROUP_STATUS, percent })
          },
        }
      )
      .then(() => {
        dispatch({ type: types.UPLOAD_GROUP_STATUS, status: '' })
        dispatch({ type: types.UPLOAD_GROUP_STATUS, percent: 0 })

        alert(
          language.alerts
            ? language.alerts.group_completion_imported_successfully
            : null
        )
      })
  }
}

export const uploadCourseCompletion = (event) => {
  return (dispatch, getState) => {
    event.preventDefault()

    const { uploadStatus } = getState().groups
    if (uploadStatus === 'started') return

    const nodes = event.target.elements
    const fileInput = [].filter.call(nodes, (item) => item.type === 'file')[0]
    const file = fileInput.files[0]
    const data = new FormData()

    data.append('file', file)

    let language = {}
    getState().language.language
      ? (language = getState().language.language.data)
      : null
    if (!file) {
      alert(language.alerts ? language.alerts.select_file : null)
      return
    }

    dispatch({ type: types.UPLOAD_GROUP_STATUS, status: 'started' })
    axios
      .post(
        `${clientBaseUrl()}/users/import-course-progress?token=${accessToken()}`,
        data,
        {
          onUploadProgress: (progressEvent) => {
            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            )

            dispatch({ type: types.UPLOAD_GROUP_STATUS, percent })
          },
        }
      )
      .then(() => {
        dispatch({ type: types.UPLOAD_GROUP_STATUS, status: '' })
        dispatch({ type: types.UPLOAD_GROUP_STATUS, percent: 0 })

        alert(
          language.alerts
            ? language.alerts.course_completion_imported_successfully
            : null
        )
      })
  }
}

export const toggleGroupLocation = (id) => {
  return (dispatch, getState) => {
    const { selectedGroupLocations } = getState().groups
    const index = selectedGroupLocations.findIndex((item) => item === id)
    if (index === -1) {
      dispatch({
        type: types.ASSING_GROUP_LOCATION,
        locations: [...selectedGroupLocations, id],
      })

      return
    }

    const newLocations = [
      ...selectedGroupLocations.slice(0, index),
      ...selectedGroupLocations.slice(index + 1),
    ]

    dispatch({ type: types.ASSING_GROUP_LOCATION, locations: newLocations })
  }
}

export const toggleGroupRole = (id) => {
  return (dispatch, getState) => {
    const { selectedRoles } = getState().groups
    const index = selectedRoles.findIndex((item) => item === id)

    if (index === -1) {
      dispatch({ type: types.SET_GROUP_ROLES, roles: [...selectedRoles, id] })

      return
    }

    const newRoles = [
      ...selectedRoles.slice(0, index),
      ...selectedRoles.slice(index + 1),
    ]

    dispatch({ type: types.SET_GROUP_ROLES, roles: newRoles })
  }
}

export const toggleUsersNotAssignedFromRole = (id) => {
  return (dispatch, getState) => {
    const { setUserNotAssignedFromRole } = getState().groups
    const index = setUserNotAssignedFromRole.findIndex((item) => item === id)

    if (index === -1) {
      dispatch({
        type: types.SET_USERS_NOT_ASSIGNED_FROM_ROLE,
        payload: [...setUserNotAssignedFromRole, id],
      })

      return
    }

    const newUsers = [
      ...setUserNotAssignedFromRole.slice(0, index),
      ...setUserNotAssignedFromRole.slice(index + 1),
    ]

    dispatch({
      type: types.SET_USERS_NOT_ASSIGNED_FROM_ROLE,
      payload: newUsers,
    })
  }
}

export const toggleAllAssignableLocations = () => {
  return (dispatch, getState) => {
    const { locations } = getState().groups
    const { selectedLocations } = getState().groups

    let groupLocations = []

    if (locations.length !== selectedLocations.length) {
      groupLocations = locations.map((item) => item.id)
    }

    dispatch({ type: types.SET_GROUP_LOCATIONS, locations: groupLocations })
    dispatch({
      type: types.SET_SELECTED_ASSIGNABLE_TRAINING_LOCATIONS,
      assignableTrainingLocations: groupLocations,
    })
  }
}

export const toggleAllManageableLocations = () => {
  return (dispatch, getState) => {
    const { locations } = getState().groups
    const { selectedLocations } = getState().groups

    let groupLocations = []

    if (locations.length !== selectedLocations.length) {
      groupLocations = locations.map((item) => item.id)
    }

    dispatch({ type: types.SET_GROUP_LOCATIONS, locations: groupLocations })
    dispatch({
      type: types.SET_SELECTED_MANAGEABLE_TRAINING_LOCATIONS,
      manageableTrainingLocations: groupLocations,
    })
  }
}

export const toggleAllAssignableStores = () => {
  return (dispatch, getState) => {
    const { stores } = getState().stores
    const { selectedStores } = getState().groups

    let groupStores = []

    if (stores.length !== selectedStores.length) {
      groupStores = stores.map((item) => item.id)
    }

    dispatch({ type: types.SET_GROUP_STORES, stores: groupStores })
    dispatch({
      type: types.SET_SELECTED_ASSIGNABLE_TRAINING_STORES,
      assignableTrainingStores: groupStores,
    })
  }
}

export const toggleAllManageableStores = () => {
  return (dispatch, getState) => {
    const { stores } = getState().stores
    const { selectedStores } = getState().groups

    let groupStores = []

    if (stores.length !== selectedStores.length) {
      groupStores = stores.map((item) => item.id)
    }

    dispatch({ type: types.SET_GROUP_STORES, stores: groupStores })
    dispatch({
      type: types.SET_SELECTED_MANAGEABLE_TRAINING_STORES,
      manageableTrainingStores: groupStores,
    })
  }
}

export const toggleAllManageableLocationGroups = () => {
  return (dispatch, getState) => {
    const { groups } = getState().groups
    const { selectedLocationGroups } = getState().groups

    let groupAssociates = []

    if (
      groups.filter((item) => item.type === 'location').length !==
      selectedLocationGroups.length
    ) {
      groupAssociates = groups
        .filter((item) => item.type === 'location')
        .map((item) => item.id)
    }

    dispatch({
      type: types.SET_GROUP_LOCATION_GROUPS,
      locationGroups: groupAssociates,
    })
    dispatch({
      type: types.SET_SELECTED_MANAGEABLE_TRAINING_LOCATION_GROUPS,
      manageableTrainingLocationGroups: groupAssociates,
    })
  }
}

export const toggleAllAssignableLocationGroups = () => {
  return (dispatch, getState) => {
    const { groups } = getState().groups
    const { selectedLocationGroups } = getState().groups

    let groupAssociates = []

    if (
      groups.filter((item) => item.type === 'location').length !==
      selectedLocationGroups.length
    ) {
      groupAssociates = groups
        .filter((item) => item.type === 'location')
        .map((item) => item.id)
    }

    dispatch({
      type: types.SET_GROUP_LOCATION_GROUPS,
      locationGroups: groupAssociates,
    })
    dispatch({
      type: types.SET_SELECTED_ASSIGNABLE_TRAINING_LOCATION_GROUPS,
      assignableTrainingLocationGroups: groupAssociates,
    })
  }
}

export const toggleAllManageableRoles = () => {
  return (dispatch, getState) => {
    const { roles } = getState().groups
    const { selectedRoles } = getState().groups

    let groupRoles = []

    if (roles.length !== selectedRoles.length) {
      groupRoles = roles.map((item) => item.id)
    }

    dispatch({ type: types.SET_GROUP_ROLES, roles: groupRoles })
    dispatch({
      type: types.SET_SELECTED_MANAGEABLE_TRAINING_ROLES,
      manageableTrainingRoles: groupRoles,
    })
  }
}

export const toggleAllAssignableRoles = () => {
  return (dispatch, getState) => {
    const { roles } = getState().groups
    const { selectedRoles } = getState().groups

    let groupRoles = []

    if (roles.length !== selectedRoles.length) {
      groupRoles = roles.map((item) => item.id)
    }

    dispatch({ type: types.SET_GROUP_ROLES, roles: groupRoles })
    dispatch({
      type: types.SET_SELECTED_ASSIGNABLE_TRAINING_ROLES,
      assignableTrainingRoles: groupRoles,
    })
  }
}

export const toggleAllAssignableRoleGroups = () => {
  return (dispatch, getState) => {
    const { groups } = getState().groups
    const { selectedRoleGroups } = getState().groups

    let allRoleGroups = []

    if (
      groups.filter((item) => item.type === 'role').length !==
      selectedRoleGroups.length
    ) {
      allRoleGroups = groups
        .filter((item) => item.type === 'role')
        .map((item) => item.id)
    }

    dispatch({ type: types.SET_ROLE_GROUPS, roleGroups: allRoleGroups })
    dispatch({
      type: types.SET_SELECTED_ASSIGNABLE_TRAINING_ROLE_GROUPS,
      assignableTrainingRoleGroups: allRoleGroups,
    })
  }
}

export const toggleAllManageableRoleGroups = () => {
  return (dispatch, getState) => {
    const { groups } = getState().groups
    const { selectedRoleGroups } = getState().groups

    let allRoleGroups = []

    if (
      groups.filter((item) => item.type === 'role').length !==
      selectedRoleGroups.length
    ) {
      allRoleGroups = groups
        .filter((item) => item.type === 'role')
        .map((item) => item.id)
    }

    dispatch({ type: types.SET_ROLE_GROUPS, roleGroups: allRoleGroups })
    dispatch({
      type: types.SET_SELECTED_MANAGEABLE_TRAINING_ROLE_GROUPS,
      manageableTrainingRoleGroups: allRoleGroups,
    })
  }
}

export const onDatesChange = (dates) => {
  return (dispatch) => {
    dispatch({
      type: types.SET_GROUP_DATES,
      startDate: dates.startDate,
      endDate: dates.endDate,
    })
    dispatch({ type: types.SET_TRAINING_DURATION, value: null })
  }
}

export const toggleDates = () => {
  return (dispatch, getState) => {
    const { dates_disabled } = getState().groups.group
    dispatch({ type: types.TOGGLE_DATES, dates_disabled: !dates_disabled })
  }
}

export const fetchUserGroupProgress = () => {
  return (dispatch, getState) => {
    AxiosInstance.get(`/users/self/group-progress`).then((data) => {
      if (data.length) {
        const newLearningPlanGroups = []

        getState().groups.learningPlanGroups.map((item) => {
          const group = data.find((groupItem) => item.id === groupItem.id)
          if (group) {
            newLearningPlanGroups.push({
              ...item,
              status: group.status,
              reassigned: group.reassigned,
              expired: group.expired,
              pastDue: group.past_due,
              endDate: group.end_date,
            })
          }
        })

        dispatch({
          type: types.SET_GROUPS_LEARNING_PLAN,
          groups: newLearningPlanGroups,
        })
        dispatch({ type: types.SET_GROUP_STATUS, groupStatus: data })
      }
    })
  }
}

export const setSearchByGroups = () => {
  return (dispatch) => {
    dispatch({ type: types.SET_SEARCH_BY_GROUPS, searchByGroups: true })
    dispatch({ type: types.SET_SEARCH_BY_COURSES, searchByCourses: false })
  }
}

export const fetchTrainigCourses = (id) => {
  return (dispatch) => {
    AxiosInstance.get(`/courses/training/${id}`).then((courses) => {
      dispatch({ type: types.SET_TRAINING_COURSES, trainingCourses: courses })
    })
  }
}

export const setTrainingDuration = (e) => {
  return (dispatch) => {
    const duration = e.target.value

    if (duration.length <= 3) {
      if (!duration || duration.match(/^\d{1,}(^\.)?$/)) {
        dispatch({ type: types.SET_TRAINING_DURATION, value: duration })
      }
    }
  }
}

export const setExpireDate = (e) => {
  return (dispatch) => {
    const expireDate = e.target.value

    if (expireDate.length <= 2) {
      if (!expireDate || expireDate.match(/^\d{1,}(^\.)?$/)) {
        dispatch({ type: types.SET_EXPIRE_DATE, value: expireDate })
      }
    }
  }
}

export const setExpirePeriod = (e) => {
  return (dispatch) => {
    const expirePeriod = e.target.value

    dispatch({ type: types.SET_EXPIRE_PERIOD, value: expirePeriod })
  }
}

export const setReassignDate = (e) => {
  return (dispatch) => {
    const reassignDate = e.target.value

    if (reassignDate.length <= 2) {
      if (!reassignDate || reassignDate.match(/^\d{1,}(^\.)?$/)) {
        dispatch({ type: types.SET_REASSIGN_DATE, value: reassignDate })
      }
    }
  }
}

export const setExpirePrior = (e) => {
  return (dispatch) => {
    const expirePrior = e.target.value

    dispatch({ type: types.SET_EXPIRE_PRIOR, value: expirePrior })
  }
}

export const setSearchByCourses = () => {
  return (dispatch) => {
    dispatch({ type: types.SET_SEARCH_BY_GROUPS, searchByGroups: false })
    dispatch({ type: types.SET_SEARCH_BY_COURSES, searchByCourses: true })
  }
}

export const resetCourseGroupFilters = () => {
  return (dispatch) => {
    dispatch(setSearchByGroups())
    dispatch(setGroupSearchValue(''))
  }
}

export const setEquivalentGroup = (value) => {
  return (dispatch) => {
    if (value) {
      const equivalentGroupId = value.option.id
      dispatch({ type: types.SET_EQUIVALENT_GROUP, value: equivalentGroupId })
    } else {
      dispatch({ type: types.SET_EQUIVALENT_GROUP, value: null })
    }
  }
}

export const saveChecklist = () => {
  return (dispatch, getState) => {
    AxiosInstance.post(`/groups/${getState().groups.group.id}/checklist`, {
      checklist: getState().groups.checklist,
    })
  }
}

const section = () => ({
  onCreate: true,
  id: randomString(),
  name: '',
  rating: 'yes-no',
  items: [
    {
      id: randomString(),
      name: '',
      value: '',
      comment: '',
    },
    {
      id: randomString(),
      name: '',
      value: '',
      comment: '',
    },
  ],
})

const sectionItem = () => ({
  id: randomString(),
  name: '',
  value: '',
  comment: '',
})

export const addSection = () => {
  return (dispatch, getState) => {
    dispatch(present())

    const { checklist } = getState().groups

    const sections = [...checklist.sections, section()]

    dispatch({ type: types.ADD_SECTION, sections })
    dispatch({ type: types.SECTION_ACTIVE_INDEX, index: sections.length - 1 })
  }
}

export const deleteSection = (index) => {
  return (dispatch, getState) => {
    let language = {}
    getState().language.language
      ? (language = getState().language.language.data)
      : null
    if (
      confirm(language.alerts ? language.alerts.delete_section_confirm : null)
    ) {
      const { sections, sectionActiveIndex } = getState().groups.checklist

      if (sectionActiveIndex !== -1) {
        index = sectionActiveIndex
      }

      const newSections = [
        ...sections.slice(0, index),
        ...sections.slice(index + 1),
      ]

      dispatch({ type: types.SECTION_ACTIVE_INDEX, index: -1 })
      dispatch({ type: types.ADD_SECTION, sections: newSections })
      dispatch(saveChecklist())
    }
  }
}

export const editSection = (index) => {
  return (dispatch) => {
    dispatch(present())

    dispatch({ type: types.SECTION_ACTIVE_INDEX, index })
  }
}

export const saveSection = () => {
  return (dispatch, getState) => {
    const { sectionActiveIndex, sections } = getState().groups.checklist
    console.log('called!')
    const section = sections[sectionActiveIndex]
    let language = {}
    getState().language.language
      ? (language = getState().language.language.data)
      : null
    if (!section.name.trim()) {
      alert(language.alerts ? language.alerts.type_section_name : null)
      return
    }

    if (!section.items.length) {
      alert(language.alerts ? language.alerts.add_item : null)
      return
    }

    console.log('leart3081', section.items)

    if (section.items.find((item) => !item?.name?.trim())) {
      alert(language.alerts ? language.alerts.add_item_value : null)
      return
    }

    const { onCreate, ...newSection } = section

    const newSections = [
      ...sections.slice(0, sectionActiveIndex),
      newSection,
      ...sections.slice(sectionActiveIndex + 1),
    ]

    dispatch({ type: types.ADD_SECTION, sections: newSections })
    dispatch(present())
    dispatch({ type: types.SECTION_ACTIVE_INDEX, index: -1 })
    dispatch(saveChecklist())
  }
}

export const addSectionItem = () => {
  return (dispatch, getState) => {
    const { sectionActiveIndex, sections } = getState().groups.checklist

    const newSections = [
      ...sections.slice(0, sectionActiveIndex),
      {
        ...sections[sectionActiveIndex],
        items: [...sections[sectionActiveIndex].items, sectionItem()],
      },
      ...sections.slice(sectionActiveIndex + 1),
    ]

    dispatch({ type: types.ADD_SECTION, sections: newSections })
  }
}

export const removeSectionItem = (itemIndex) => {
  return (dispatch, getState) => {
    const { sections, sectionActiveIndex } = getState().groups.checklist

    const newSections = [
      ...sections.slice(0, sectionActiveIndex),
      {
        ...sections[sectionActiveIndex],
        items: [
          ...sections[sectionActiveIndex].items.slice(0, itemIndex),
          ...sections[sectionActiveIndex].items.slice(itemIndex + 1),
        ],
      },
      ...sections.slice(sectionActiveIndex + 1),
    ]

    dispatch({ type: types.ADD_SECTION, sections: newSections })
  }
}

export const saveDescription = () => {
  return (dispatch) => {
    dispatch(present())
    dispatch({ type: types.SECTION_ACTIVE_INDEX, index: -1 })
    dispatch(saveChecklist())
  }
}
export const cancelSection = () => {
  return (dispatch, getState) => {
    dispatch({ type: types.SECTION_ACTIVE_INDEX, index: -1 })
    dispatch({ type: types.CANCEL_SECTION })
  }
}

export const prevChecklistDescription = (prevChecklistDescription) => {
  return (dispatch) => {
    dispatch({
      type: types.PREV_CHECKLIST_DESCRIPTION,
      value: prevChecklistDescription,
    })
  }
}

export const onChangeSection = (event) => {
  return (dispatch, getState) => {
    const name = event.target.name
    const value = event.target.value
    const { sections, sectionActiveIndex } = getState().groups.checklist

    const newSections = [
      ...sections.slice(0, sectionActiveIndex),
      { ...sections[sectionActiveIndex], [name]: value },
      ...sections.slice(sectionActiveIndex + 1),
    ]

    dispatch({ type: types.ADD_SECTION, sections: newSections })
  }
}

export const onChangeSectionItem = (itemIndex, value) => {
  return (dispatch, getState) => {
    const { sections, sectionActiveIndex } = getState().groups.checklist

    const newSections = [
      ...sections.slice(0, sectionActiveIndex),
      {
        ...sections[sectionActiveIndex],
        items: [
          ...sections[sectionActiveIndex].items.slice(0, itemIndex),
          { ...sections[sectionActiveIndex].items[itemIndex], name: value },
          ...sections[sectionActiveIndex].items.slice(itemIndex + 1),
        ],
      },
      ...sections.slice(sectionActiveIndex + 1),
    ]

    dispatch({ type: types.ADD_SECTION, sections: newSections })
  }
}

export const onChangeDescription = (name, value) => ({
  type: types.UPDATE_DESCRIPTION,
  name,
  value,
})

export const onClickSearchGroup = () => {
  return (dispatch, getState) => {
    const value = getState().groups.groupSearchValue
    dispatch({ type: types.SET_SEARCH_GROUP_ON_CLICK, value })
  }
}
export const onResetSearchGroup = () => {
  return (dispatch) => {
    dispatch({ type: types.SET_SEARCH_GROUP_ON_CLICK, value: '' })
  }
}
